import { render } from "./BorderColor.vue?vue&type=template&id=0089d9d6&scoped=true&ts=true"
import script from "./BorderColor.vue?vue&type=script&lang=ts"
export * from "./BorderColor.vue?vue&type=script&lang=ts"

import "./BorderColor.vue?vue&type=style&index=0&id=0089d9d6&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0089d9d6"]])

export default __exports__